// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file apps_service.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { App } from "./app_pb";
import { file_app } from "./app_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file apps_service.proto.
 */
export const file_apps_service: GenFile = /*@__PURE__*/
  fileDesc("ChJhcHBzX3NlcnZpY2UucHJvdG8SC2dycGMuYXBpLnYxIisKCkFwcFJlcXVlc3QSHQoDYXBwGAEgASgLMhAuZ3JwYy5hcGkudjEuQXBwIiwKC0FwcFJlc3BvbnNlEh0KA2FwcBgBIAEoCzIQLmdycGMuYXBpLnYxLkFwcDLLAQoLQXBwc1NlcnZpY2USOwoGZ2V0QXBwEhcuZ3JwYy5hcGkudjEuQXBwUmVxdWVzdBoYLmdycGMuYXBpLnYxLkFwcFJlc3BvbnNlEj4KCXVwZGF0ZUFwcBIXLmdycGMuYXBpLnYxLkFwcFJlcXVlc3QaGC5ncnBjLmFwaS52MS5BcHBSZXNwb25zZRI/CgppbnN0YWxsQXBwEhcuZ3JwYy5hcGkudjEuQXBwUmVxdWVzdBoYLmdycGMuYXBpLnYxLkFwcFJlc3BvbnNlQgZaBC47cGJiBnByb3RvMw", [file_app]);

/**
 * @generated from message grpc.api.v1.AppRequest
 */
export type AppRequest = Message<"grpc.api.v1.AppRequest"> & {
  /**
   * @generated from field: grpc.api.v1.App app = 1;
   */
  app?: App | undefined;
};

/**
 * Describes the message grpc.api.v1.AppRequest.
 * Use `create(AppRequestSchema)` to create a new message.
 */
export const AppRequestSchema: GenMessage<AppRequest> = /*@__PURE__*/
  messageDesc(file_apps_service, 0);

/**
 * @generated from message grpc.api.v1.AppResponse
 */
export type AppResponse = Message<"grpc.api.v1.AppResponse"> & {
  /**
   * @generated from field: grpc.api.v1.App app = 1;
   */
  app?: App | undefined;
};

/**
 * Describes the message grpc.api.v1.AppResponse.
 * Use `create(AppResponseSchema)` to create a new message.
 */
export const AppResponseSchema: GenMessage<AppResponse> = /*@__PURE__*/
  messageDesc(file_apps_service, 1);

/**
 * @generated from service grpc.api.v1.AppsService
 */
export const AppsService: GenService<{
  /**
   * @generated from rpc grpc.api.v1.AppsService.getApp
   */
  getApp: {
    methodKind: "unary";
    input: typeof AppRequestSchema;
    output: typeof AppResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.AppsService.updateApp
   */
  updateApp: {
    methodKind: "unary";
    input: typeof AppRequestSchema;
    output: typeof AppResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.AppsService.installApp
   */
  installApp: {
    methodKind: "unary";
    input: typeof AppRequestSchema;
    output: typeof AppResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_apps_service, 0);

